export default __webpack_public_path__ + "static/media/Mall_Aventura.0962c21c.svg";